module.exports = __webpack_public_path__ + "img/I2C_Fig06.91f9a71d.png";